export default {
  data() {
    return {
      errors: [],
      loading: false,
      wasSubmitted: false,
    };
  },
  methods: {
    async submit() {
      this.errors = [];

      if (this.$v && this.$v.$invalid) {
        this.$v.$touch();

        this.afterValidation();

        return;
      }

      this.loading = true;

      try {
        return await this.onSubmit();
      }
      catch (error) {
        this.errors = error.customErrors;
        return false;
      }
      finally {
        this.loading = false;
      }
    },

    async onSubmit() { },
    afterValidation() { }
  }
}